"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { SelectInput, TextAreaInput } from '@autoguru/overdrive';
import { useField } from 'formik';
const noValidationIconInputTypes = new Set([TextAreaInput, SelectInput]);
export const useOdFormicField = ({
  name,
  successIcon,
  errorIcon,
  suffixIcon,
  InputField,
  validate
}) => {
  const [field, meta] = useField({
    name
  });
  const {
    touched,
    error
  } = meta;
  const validatorErrors = typeof validate === 'function' ? validate(field.value, name) : null;
  const isValid = !error && !validatorErrors;
  // @ts-ignore
  const fieldIcon = noValidationIconInputTypes.has(InputField) ? null : suffixIcon ? suffixIcon : isValid ? Boolean(successIcon) && touched ? successIcon : null : Boolean(errorIcon) && touched ? errorIcon : null;
  return {
    field,
    isValid,
    fieldIcon,
    touched,
    error: validatorErrors || error
  };
};